import { IAuthFormData } from '../model/types/AuthFormData';

export const defaultState: IAuthFormData = {
  email: '',
  password: '',
  // remember: false,
};
